import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login/index.vue'),
    meta: { title: '登录页' }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/agreement/index.vue'),
    meta: { title: '用户注册协议' }
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import('@/views/policy/index.vue'),
    meta: { title: '隐私政策' }
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: () => import('@/views/forgot/index.vue'),
    meta: { title: '验证手机号' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "Register" */ '../views/register/index.vue'),
    meta: { title: '注册页' }
  },
  {
    path: '/reset',
    name: 'Reset',
    component: () => import('@/views/reset/index.vue'),
    meta: { title: '重置密码' }
  },
  {
    path: '/splashscreen',
    name: 'SplashScreen',
    component: () => import('@/views/SplashScreen/index.vue'),
    meta: { title: '启动页' }
  },
  // {
  //   path: '/',
  //   redirect: '/SplashScreen',
  //   children: [
  //     {
  //       path: '',
  //       name: 'SplashScreen',
  //       component: () => import(/* webpackChunkName: "SplashScreen" */ '@/views/SplashScreen/index.vue'),
  //       meta: { title: '启动页' }
  //     }
  //   ]
  // },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页' }
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('@/views/Service/index.vue'),
    meta: { title: '客服服务' }
  },
  {
    path: '/classify',
    name: 'Classify',
    component: () => import('@/views/Classify/index.vue'),
    meta: { title: '分类' }
  },
  {
    path: '/goodssearch',
    name: 'GoodsSearch',
    component: () => import('@/views/GoodsSearch/index.vue'),
    meta: { title: '商品搜索' }
  },
  {
    path: '/goodslist',
    name: 'GoodsList',
    component: () => import('@/views/GoodsList/index.vue'),
    meta: { title: '商品列表' }
  },
  {
    path: '/shopCart',
    name: 'ShopCart',
    component: () => import('@/views/ShopCart/index.vue'),
    meta: { title: '购物车' }
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('@/views/User/index.vue'),
    meta: { title: '个人中心' }
  },
  {
    path: '/goodsDetail/:id',
    name: 'GoodsDetail',
    component: () => import('@/views/GoodsDetail/index.vue'),
    meta: { title: '商品详情' }
  },
  {
    path: '/confirmOrder',
    name: 'ConfirmOrder',
    component: () => import('@/views/ConfirmOrder/index.vue'),
    meta: { title: '确认订单' }
  },
  {
    path: '/cashier',
    name: 'Cashier',
    component: () => import('@/views/cashier/index.vue'),
    meta: { title: '收银台' }
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('@/views/success/index.vue'),
    meta: { title: '支付状态' }
  },
  {
    path: '/remark',
    name: 'Remark',
    component: () => import('@/views/remark/index.vue'),
    meta: { title: '备注' }
  },
  {
    path: '/address',
    name: 'Address',
    component: () => import('@/views/Address/index.vue'),
    meta: { title: '地址管理' }
  },
  {
    path: '/orderlist',
    name: 'OrderList',
    component: () => import('@/views/OrderList/index.vue'),
    meta: { title: '订单列表' }
  },
  {
    path: '/orderdetails/:id',
    name: 'OrderDetails',
    component: () => import('@/views/OrderDetails/index.vue'),
    meta: { title: '订单详情' }
  },
  {
    path: '/newAddress',
    name: 'NewAddress',
    component: () => import('@/views/NewAddress/index.vue'),
    meta: { title: '新建收货地址' }
  },
  {
    path: '/giftCard',
    name: 'GiftCard',
    component: () => import('@/views/GiftCard/index.vue'),
    meta: { title: '礼品券' }
  },
  {
    path: '/giftCenter',
    name: 'GiftCenter',
    component: () => import('@/views/giftCenter/index.vue'),
    meta: { title: '礼品卡中心' }
  },
  {
    path: '/activation',
    name: 'Activation',
    component: () => import('@/views/activation/index.vue'),
    meta: { title: '激活中心' }
  },
  {
    path: '/exchange',
    name: 'Exchange',
    component: () => import('@/views/exchange/index.vue'),
    meta: { title: '兑换中心' }
  },
  {
    path: '/giftdetails',
    name: 'GiftDetails',
    component: () => import('@/views/giftdetails/index.vue'),
    meta: { title: '查看明细' }
  },
  {
    path: '/balance',
    name: 'Balance',
    component: () => import('@/views/Balance/index.vue'),
    meta: { title: '余额' }
  },
  {
    path: '/balancedetails',
    name: 'BalanceDetails',
    component: () => import('@/views/BalanceDetails/index.vue'),
    meta: { title: '余额明细' }
  },
  {
    path: '/balancetopup',
    name: 'BalanceTopUp',
    component: () => import('@/views/BalanceTopUp/index.vue'),
    meta: { title: '余额充值 ' }
  },
  {
    path: '/logisticlist',
    name: 'Logisticlist',
    component: () => import('@/views/LogisticList/index.vue'),
    meta: { title: '物流列表' }
  },
  {
    path: '/logistic',
    name: 'Logistic',
    component: () => import('@/views/Logistic/index.vue'),
    meta: { title: '物流信息' }
  }
  // {
  //   path: '/second',
  //   name: 'second',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/second.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
